import {
	ComplaintReason,
	ComplaintReasonTextDE,
	ComplaintReasonTextEN,
	TreatmentStatus
} from "libs/treatments/src/lib/models/treatment.model";
import {
	MessageModel,
	MessageScopes,
	MessageTypes,
	SendersTypes
} from "../models/message.model";

export class StatusService {

	static getStatusChangeLogMessage(oldStatus: TreatmentStatus, newStatus: TreatmentStatus, isCustomerFrontend: boolean = false){
		return `Treatment-Status von
		[${this.getStatusStringFromKey(oldStatus, isCustomerFrontend)}] auf
		[${this.getStatusStringFromKey(newStatus, isCustomerFrontend)}] geändert.`;
	}

	static createStatusChangeLogMessageModel(
		oldStatus: TreatmentStatus,
		newStatus: TreatmentStatus,
		treatmentId: string,
		isCustomerFrontend: boolean = false
	): MessageModel {
		const message = this.getStatusChangeLogMessage(oldStatus, newStatus, isCustomerFrontend);

		const logMessageModel: MessageModel = {
			message: message,
			scope: MessageScopes.Intern,
			sendersType: SendersTypes.System,
			type: MessageTypes.StatusChange,
			context: {
				id: treatmentId,
				status: newStatus
			}
		};
		return logMessageModel;
	}

	static getComplaintMessagePrefix(lang?: "de" | "en"): string {
		return lang === "de" ? "Reklamationsgrund:" : "Complaint reason:";
	}

	static getComplaintReasonText(
		key: ComplaintReason,
		lang?: "de" | "en"
	): string {
		return lang === "de"
			? ComplaintReasonTextDE[key]
			: ComplaintReasonTextEN[key];
	}

	static getStatusStringFromKey(value: TreatmentStatus, isCustomerFrontend: boolean = false): string {
		switch (value) {
			case TreatmentStatus.NewRequestReceived:
				return "Anfrage eingegangen";
			case TreatmentStatus.Planning:
				return "Planung";
			case TreatmentStatus.DataReceived:
				return "Daten vorhanden";
			case TreatmentStatus.RescanImprintsRequired:
				return isCustomerFrontend
					? "Modelle angekommen"
					: "Modelle erneut scannen";
			case TreatmentStatus.NewImprintsRequested:
				return "Modelle erwartet";
			case TreatmentStatus.NewDataRequested:
				return "Neue Daten benötigt";
			case TreatmentStatus.ConsultationRequired:
				return "Rücksprache erforderlich";
			case TreatmentStatus.Shipped:
				return "Auftrag versendet";
			case TreatmentStatus.Canceled:
				return "Storniert";
			case TreatmentStatus.CreditMemoIssued:
				return "Gutschrift";
			case TreatmentStatus.Postponed:
				return "Zurückgestellt";
			case TreatmentStatus.ConsultationComplete:
				return "Rücksprache erledigt";
			case TreatmentStatus.ExportRequired:
				return isCustomerFrontend
					? "Produktion"
					: "Export"
			case TreatmentStatus.InProduction:
				return "Produktion";
			case TreatmentStatus.ReleaseRequested:
				return "Freigabe angefordert";
			case TreatmentStatus.CorrectionRequestReceived:
				return "Korrektur angefordert";
			case TreatmentStatus.Closed:
				return "Closed";
			case TreatmentStatus.RequestRejected:
				return "Absage";
			case TreatmentStatus.ComplaintReceived:
				return "Reklamation eingereicht";
			case TreatmentStatus.ComplaintResolved:
				return "Reklamation geklärt";
			case TreatmentStatus.RefinementRequestReceived:
				return "Refinement angefordert";
			case TreatmentStatus.RefinementReleaseRequested:
				return "Refinement Freigabe angefordert";
			case TreatmentStatus.Goodwill:
				return "Kulanz";
			case TreatmentStatus.CaseAssessmentSubmitted:
				return isCustomerFrontend
					? "Einschätzung erhalten"
					: "Einschätzung abgegeben"
			default:
				return "";
		}
	}
}
